import { render, staticRenderFns } from "./CriterionCard.vue?vue&type=template&id=3cf069c6&scoped=true"
import script from "./CriterionCard.vue?vue&type=script&lang=js"
export * from "./CriterionCard.vue?vue&type=script&lang=js"
import style0 from "./CriterionCard.vue?vue&type=style&index=0&id=3cf069c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf069c6",
  null
  
)

export default component.exports